<template>
  <el-scrollbar wrapClass="scrollbar-wrapper">
    <el-menu mode="vertical" :show-timeout="200" :default-active="$route.path" :collapse="isCollapse"
      :text-color="textColor" :active-text-color="textColorActive">
      <sidebar-item :routes="permission_routers"></sidebar-item>
    </el-menu>
  </el-scrollbar>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'
import powered from '@/assets/group-5.png'
import { colors } from '@/styles/variables.js'

export default {
  components: { SidebarItem },
  computed: {
    ...mapGetters([
      'permission_routers',
      'sidebar'
    ]),
    isCollapse() {
      return !this.sidebar.opened
    }
  },
  data() {
    return {
      powered,
      textColor: colors.sidebarMenuItemTextColor,
      textColorActive: colors.sidebarMenuItemTextColorActive
    }
  },
  methods: {

  }
}
</script>
<style lang="scss">
// .scrollbar-wrapper {
//margin-top: 50px;
// }
.poweredBy {
  width: 80%;
  margin: 0 auto;
  object-fit: contain;
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue